<template>
  <div class="flex-wrap flex just-between align-i-c header">
    <MainInfo class="z-1000" />
    <MenuNavigation />
  </div>
</template>

<script setup>
// src/components/navigation/MainNavigation.vue
import MainInfo from './MainInfo.vue'
import MenuNavigation from '@/components/navigation/MenuNavigation.vue'
</script>
